import { default as useBadgeWrapper } from "./create-badge-wrapper"

export default useBadgeWrapper
